import React, { useState, useEffect } from 'react';
import '../../css/card.css';

const Card = ({ data }) => {
    return (
        <div className="loop-title-item">
            <span className="card-loop-input">{data.input}</span>
        </div>
    );
};

const LoopTitle = ({ data }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % data.loopTitle.length);
        }, 2000); // Daha hızlı bir döngü için süreyi 2 saniye yaptık

        return () => clearInterval(interval);
    }, [data.loopTitle.length]);

    const { title, description, loopTitle } = data;

    return (
        <div className="card">
            <div className="card-left">
                <h2 className="card-title">{title}</h2>
                <ul className="card-loop-list">
                    <li className="card-loop-item">
                        <Card data={loopTitle[currentIndex]} />
                    </li>
                </ul>
            </div>
            <div className="card-right">
                <p className="card-description">{description}</p>
            </div>
        </div>
    );
};

export default LoopTitle;
